import UAParser from "my-ua-parser";

export const isRunningOnClient = (): boolean => typeof window !== "undefined";

export const isIOS = (): boolean =>
  isRunningOnClient() &&
  /iPad|iPhone|iPod/.test(navigator.userAgent) &&
  !(window as { MSStream?: unknown }).MSStream;

export const isSafari = (): boolean =>
  isRunningOnClient() &&
  /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const isIOSSafari = (): boolean => isIOS() && isSafari();

export const isSamsungBrowser = (): boolean =>
  isRunningOnClient() && /SamsungBrowser/i.test(navigator.userAgent);

export const isMobile = (): boolean => {
  if (typeof window === "undefined") return false;
  const parser = new UAParser(navigator.userAgent);
  const ua = parser.getDevice();
  return ua.type === "mobile";
};

// create a utl for isDesktop
export const isDesktop = (): boolean => {
  if (typeof window === "undefined") return false;
  const parser = new UAParser(navigator.userAgent);
  const ua = parser.getDevice();
  return ua.type === "desktop";
};

export const isFacebookBrowser = (): boolean => {
  if (!isRunningOnClient()) return false;
  const parser = new UAParser(navigator.userAgent);
  const browser = parser.getBrowser();
  return browser.name === "Facebook";
};

/**
 * FBAN - Facebook App Native
 * FBAV - Facebook App Version
 * FBBV - Facebook Build Version
 * FBDV - Facebook Device
 * FBMD - Facebook Mobile Device
 * FBSN - Facebook System Name
 * FBSV - Facebook System Version
 * FBSS - Facebook Screen Scale
 * FBCR - Facebook Carrier
 * FBID - Facebook ID
 * FBLC - Facebook Locale
 * FBOP - Facebook Operations
 * FB_IAB - Facebook In-App Browser
 */
export const inFacebookBrowser = (): boolean => {
  if (!isRunningOnClient()) return false;
  const hasFacebookUserAgent =
    /FBAN|FBAV|FBBV|FBDV|FBMD|FBSN|FBSV|FBSS|FBCR|FBID|FBLC|FBOP|FB_IAB|Instagram/.test(
      navigator.userAgent,
    );
  return hasFacebookUserAgent;
};

export const isTikTokBrowser = (): boolean => {
  if (!isRunningOnClient()) return false;
  const hasTikTokUserAgent = /musical_ly|AppName\/trill/i.test(
    navigator.userAgent,
  );
  return hasTikTokUserAgent;
};

export const isXBrowser = (): boolean => {
  if (!isRunningOnClient()) return false;
  const hasXUserAgent = /Twitter|TwitterAndroid|com\.twitter\.android/.test(
    navigator.userAgent,
  );
  return hasXUserAgent;
};
